import React from 'react';
import { useTranslation } from 'react-i18next';

// The toolface dial, ported from public/files/Remote Display.html so the remote viewer and
// the LAN one look like siblings. Plain SVG rather than ECharts or p5: the target isn't
// DrillTrak's chart style, it's Navigator's own steering dial, because the whole point is
// that the remote watcher sees what the operator sees.
//
// Colours match the desktop app - blue for gravity toolface (high side), red for gyro
// toolface (steering).
const HIGHSIDE = '#4a7c9b';
const STEERING = '#c45c4b';

export const toolfaceColour = (mode) => (mode === 'Steering' ? STEERING : HIGHSIDE);

// The exact wording on the operator's screen. The remote watcher and the operator should be
// reading the same words, not two names for the same number.
export const toolfaceLabel = (mode) =>
    mode === 'Steering' ? 'Gyro Toolface' : 'Gravity Toolface';

export const ToolfaceDial = ({ value, mode, size = 250 }) => {
    const { t } = useTranslation();
    const colour = toolfaceColour(mode);
    const hasValue = value !== null && value !== undefined && !isNaN(value);
    // Zero is straight up and the needle turns clockwise, matching the tool's own convention.
    const rotation = hasValue ? Number(value) : 0;
    const reading = hasValue
        ? t('remote.dialDegrees', { value: Number(value).toFixed(2) })
        : t('remote.dialUnavailable');

    return (
        <svg width={size} height={size} viewBox="0 0 250 250" role="img"
            aria-label={`${toolfaceLabel(mode)} ${reading}`}>
            <circle cx="125" cy="125" r="120" fill="#f9f7f4" stroke="#d4cfc4" strokeWidth="2" />
            {[100, 80, 60, 40, 20].map(r => (
                <circle key={r} cx="125" cy="125" r={r} fill="none" stroke="#e8e4db" strokeWidth="1" />
            ))}

            <line x1="5" y1="125" x2="245" y2="125" stroke="#d4cfc4" strokeWidth="1" />
            <line x1="125" y1="5" x2="125" y2="245" stroke="#d4cfc4" strokeWidth="1" />
            <line x1="40" y1="40" x2="210" y2="210" stroke="#e8e4db" strokeWidth="1" />
            <line x1="210" y1="40" x2="40" y2="210" stroke="#e8e4db" strokeWidth="1" />

            <text x="125" y="20" textAnchor="middle" fill="#4a3f2a" fontSize="12" fontWeight="600">0</text>
            <text x="235" y="130" textAnchor="middle" fill="#4a3f2a" fontSize="12" fontWeight="600">90</text>
            <text x="125" y="242" textAnchor="middle" fill="#4a3f2a" fontSize="12" fontWeight="600">180</text>
            <text x="15" y="130" textAnchor="middle" fill="#4a3f2a" fontSize="12" fontWeight="600">270</text>

            {hasValue && (
                <g transform={`rotate(${rotation}, 125, 125)`}>
                    <line x1="125" y1="125" x2="125" y2="25" stroke={colour} strokeWidth="4" strokeLinecap="round" />
                    <circle cx="125" cy="25" r="6" fill={colour} />
                    <circle cx="125" cy="125" r="10" fill={colour} />
                </g>
            )}
        </svg>
    );
};
